import { useCallback, useEffect, useState } from "react";
import { singletonHook } from "react-singleton-hook";
import { debounce } from "cayo.ui";
import { CSSProperties } from "styled-components";
import { IContextPanel } from "@cayo/shared/api/types/schema";
import { IClosableComponent } from "@cayo/shared/components/surfaces/Panel/types";

// TODO: get rid off singleton hook
const _useContextPanel = () => {
  const [contextPanel, setContextPanel] = useState<
    (IContextPanel & IClosableComponent & { style?: CSSProperties }) | undefined
  >(undefined);

  const [contextPanelVisible, setContextPanelVisible] = useState(false);

  const showСontextPanel = useCallback(
    (panel?: IContextPanel & IClosableComponent & { style?: CSSProperties }) => {
      setContextPanel(undefined);

      debounce(() => {
        setContextPanel(panel);
        setContextPanelVisible(panel !== undefined);
      }, 0)();
    },
    [contextPanel]
  );

  useEffect(() => {
    return () => contextPanel?.onClosed && contextPanel!.onClosed();
  }, [contextPanel]);

  return {
    contextPanel,
    showСontextPanel,
    hideContextPanel: () => showСontextPanel(undefined),
    contextPanelVisible,
  };
};

export const useContextPanel = singletonHook(
  {
    contextPanel: undefined,
    showСontextPanel: () => null,
    hideContextPanel: () => null,
    contextPanelVisible: false,
  },
  _useContextPanel
);
